import { useEffect, useRef } from 'react';

import { useLocale } from './useLocale';
import { useGetProfile } from '../api/lendingApi/lendingApiQueries';
import { TIP_PORTAL_PATH_DE, TIP_PORTAL_PATH_UK } from '../constants';
import logger from '../utils/logger';

/**
 * Redirects a logged-in broker (`user_type === 'introducer'`) away from the
 * customer signup to The Introducer Portal. The signup flow isn't built for
 * brokers: it creates a customer and then fails the application step, leaving
 * an orphan. TIP paths are same-origin, so this works on prod and staging.
 */
export const useBrokerRedirect = () => {
  const { profile } = useGetProfile();
  const { isDE } = useLocale();
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    if (hasRedirectedRef.current) return;
    if (profile?.user_type !== 'introducer') return;

    hasRedirectedRef.current = true;
    logger.info('Redirecting logged-in broker from signup to TIP', { isDE });
    window.location.href = isDE ? TIP_PORTAL_PATH_DE : TIP_PORTAL_PATH_UK;
  }, [profile, isDE]);
};
